import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import Text from 'UIKit/Text'
import React, { useEffect, useRef, useState } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { delayed } from 'utils'

interface ClaimAirdropFirstTimeProps extends BoxProps {
  confirm: () => void
  delayDisplay: number
}

const ClaimAirdropFirstTime: React.FC<ClaimAirdropFirstTimeProps> = ({ confirm, delayDisplay }) => {
  const isMounted = useRef(false)
  const [hide, setHide] = useState(true)

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      setTimeout(() => {
        setHide(false)
      }, delayDisplay)
    }
  }, [delayDisplay])

  const onConfirm = async () => {
    setHide(true)
    await delayed(300)
    confirm()
  }
  return (
    <StyledModalInstructionFirstTime style={{ opacity: hide ? 0 : 1 }}>
      <TitleModalInstructionFirstTime>HUSD Airdrop</TitleModalInstructionFirstTime>
      <Instruction>
        <Trans>
          When you bet, you open up the opportunity to receive an airdrop from HunnyPlay. The more you bet, the higher
          your chance of getting one.
        </Trans>
      </Instruction>
      <Flex width="100%" justifyContent="flex-end">
        <StyledButton onClick={onConfirm}>
          <Text color="#16191f" fontWeight={700} fontSize="10px">
            <Trans>Got it</Trans>
          </Text>
        </StyledButton>
      </Flex>
    </StyledModalInstructionFirstTime>
  )
}

const StyledModalInstructionFirstTime = styled(Box)`
  width: 280px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: -275%;
  left: -205%;
  opacity: 0;
  transition: 0.3s;

  &:after {
    content: '';
    position: absolute;
    top: 96%;
    left: 44%;
    width: 10px;
    height: 10px;
    transform: rotate(135deg);
    background: #fff;
  }
`

const TitleModalInstructionFirstTime = styled(Text)`
  color: #000;
  font-size: 16px;
  font-weight: 700;
`

const Instruction = styled(Text)`
  color: #484f5d;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
  line-height: normal;
  letter-spacing: -0.24px;
`

const StyledButton = styled(Button)`
  background: rgba(22, 25, 31, 0.08);
  max-height: 23px;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 2px;
`

export default ClaimAirdropFirstTime
